export default __webpack_public_path__ + "static/char-32-anr-4cff4c828dccc5d869ecf9104ff6e2f7.webp";